export const sortByDate = (items, dateField, ascending = false) => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return []
  }

  return [...items].sort((a, b) => {
    if (!a[dateField]) return ascending ? -1 : 1
    if (!b[dateField]) return ascending ? 1 : -1

    const dateA = new Date(a[dateField])
    const dateB = new Date(b[dateField])

    if (Number.isNaN(dateA.getTime())) return ascending ? -1 : 1
    if (Number.isNaN(dateB.getTime())) return ascending ? 1 : -1

    return ascending ? dateA - dateB : dateB - dateA
  })
}
